import { render, staticRenderFns } from "./WavveVoucherList.vue?vue&type=template&id=53f0b34b"
import script from "./WavveVoucherList.vue?vue&type=script&setup=true&lang=js"
export * from "./WavveVoucherList.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/assets/scss/category/ticket.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports